export const IntegrationMessagesToIgnoreColumns = {
	model: [
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
		},
		{
			label: 'Message',
			key: 'message'
		},
	],

	formBuilderConfig: {
		trackingSystem: {
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			type: 'select',
			DataType: 'Selector',
			UIControl: 'Dropdown',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
		},
		message: {
			DataType: 'String',
			DisplayText: 'Message',
			Name: 'message'
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}
